<template>
  <div class="wallet-page">
    <div class="wallet-container">
      <!-- 加载状态 -->
      <div v-if="loading" class="loading-state">
        <div class="loading-spinner"></div>
        <p>Loading...</p>
      </div>

      <div v-else class="wallet-content">
        <div class="balance-card">
          <h2>Points Balance</h2>
          <div class="balance-info">
            <div class="balance-item available">
              <span class="label">Current Points</span>
              <span class="value">{{ userInfo.score }}</span>
            </div>
            <div class="balance-item available">
              <span class="label">Locked Points</span>
              <span class="value locked">{{ userInfo.lockscore }}</span>
            </div>
            <div class="balance-item available">
              <span class="label">Withdrawable Points</span>
              <span class="value highlight">{{ availableScore }}</span>
            </div>
          </div>
        </div>

        <div class="withdraw-card">
          <h3>Withdraw Points</h3>
          <div class="withdraw-form">
            <div class="form-group">
              <label>Points to Withdraw</label>
              <input 
                type="number" 
                v-model.number="withdrawAmount" 
                class="form-control" 
                placeholder="Enter points to withdraw"
                min="1"
                :max="availableScore"
              />
              <small class="form-hint">Available: {{ availableScore }} points</small>
            </div>
            <div class="form-group">
              <label>PayPal Account</label>
              <input 
                type="text" 
                v-model="paypaluser" 
                class="form-control" 
                placeholder="Enter PayPal account"
              />
            </div>
            <button 
              class="btn-withdraw" 
              @click="handleWithdraw"
              :disabled="submitting"
            >
              {{ submitting ? 'Submitting...' : 'Submit Withdrawal' }}
            </button>
          </div>
        </div>

        <div class="info-card">
          <h4>Withdrawal Notes</h4>
          <ul>
            <li>Withdrawable points = Current points - Locked points</li>
            <li>Minimum withdrawal is 100 points and cannot exceed available points</li>
            <li>Withdrawals are subject to review; points will be transferred upon approval</li>
            <li>For any questions, please contact customer support</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { userApi } from '@/api'
import userStore from '@/store/user.js'

export default {
  name: 'Wallet',
  data() {
    return {
      userStore: userStore.state,
      loading: false,
      submitting: false,
      userInfo: {
        score: 0,
        lockscore: 0
      },
      withdrawAmount: '',
      paypaluser:''
    }
  },
  computed: {
    availableScore() {
      return Math.max(0, this.userInfo.score - this.userInfo.lockscore)
    }
  },
  async mounted() {
    // 检查登录状态
    userStore.checkAuth()
    
    if (!this.userStore.isLoggedIn) {
      this.$toast('Please log in first')
      this.$router.push('/').catch(() => {})
      return
    }
    
    await this.loadUserInfo()
  },
  methods: {
    async loadUserInfo() {
      try {
        this.loading = true
        const response = await userApi.getUserInfo()
        
        console.log('用户信息响应:', response)
        
        if (response.code === 1 && response.data) {
          this.userInfo.score = response.data.score || 0
          this.userInfo.lockscore = response.data.lockscore || 0
          
          console.log('积分信息:', {
            score: this.userInfo.score,
            lockscore: this.userInfo.lockscore,
            available: this.availableScore
          })
        } else {
          this.$toast('Failed to load user info: ' + (response.msg || 'Unknown error'), 3000)
        }
      } catch (error) {
        console.error('Failed to load user info:', error)
        this.$toast('Load failed, please refresh the page', 3000)
      } finally {
        this.loading = false
      }
    },
    async handleWithdraw() {
      // 验证输入
      if (!this.withdrawAmount || this.withdrawAmount <= 0) {
        this.$toast('Please enter a valid withdrawal amount')
        return
      }
      
      // 验证最小提现积分
      if (this.withdrawAmount < 100) {
        this.$toast('Minimum withdrawal is 100 points', 3000)
        return
      }
      
      // 验证可提现积分
      if (this.withdrawAmount > this.availableScore) {
        this.$toast(`Insufficient points! Available: ${this.availableScore}`, 3000)
        return
      }
      
      // 确认提现
      const confirmed = await this.$confirm(`Confirm withdrawal of ${this.withdrawAmount} points?`)
      if (!confirmed) {
        return
      }
      
      try {
        this.submitting = true
        const response = await userApi.cashout(this.withdrawAmount,this.paypaluser)
        
        console.log('提现响应:', response)
        
        if (response.code === 1) {
          this.$toast(response.msg || 'Submitted successfully, pending review', 3000)
          this.withdrawAmount = ''
          this.paypaluser = ''
          // 重新加载用户信息
          await this.loadUserInfo()
        } else {
          this.$toast(response.msg || 'Withdrawal failed', 3000)
        }
      } catch (error) {
        console.error('Failed to withdraw:', error)
        this.$toast('Withdrawal failed, please try again', 3000)
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.wallet-page {
  min-height: 100vh;
}

.wallet-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 30px 20px;
}

/* 加载状态 */
.loading-state {
  background: white;
  padding: 80px 40px;
  text-align: center;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #ffc200;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-state p {
  color: #666;
  font-size: 16px;
  margin: 0;
}

.wallet-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* 积分信息卡片 */
.balance-card {
  background: #fff;
  color: #000;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(216, 216, 216, 0.3);
}

.balance-card h2 {
  margin: 0 0 20px 0;
  font-size: 20px;
  font-weight: 600;
  opacity: 0.9;
}

.balance-info {
  display: flex;
  gap: 15px;
}

.balance-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  padding: 15px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  backdrop-filter: blur(10px);
  
}

.balance-item.available {
  background: rgba(255, 255, 255, 0.5);
  border: 2px solid rgba(0, 0, 0, 0.2);
}

.balance-item .label {
  font-size: 14px;
  opacity: 0.85;
  font-weight: 500;
  color: #000;
}

.balance-item .value {
  font-size: 24px;
  font-weight: bold;
}

.balance-item .value.locked {
  color: rgba(0, 0, 0, 0.6);
}

.balance-item .value.highlight {
  color: #000;
  font-size: 28px;
}

/* 提现表单 */
.withdraw-card {
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.withdraw-card h3 {
  margin: 0 0 20px 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.withdraw-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.form-control {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  transition: border-color 0.3s;
  box-sizing: border-box;
}

.form-control:focus {
  outline: none;
  border-color: #ffc200;
}

.form-hint {
  font-size: 12px;
  color: #999;
}

.btn-withdraw {
  padding: 14px 30px;
  background: #ffc200;
  color: #000;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s;
}

.btn-withdraw:hover:not(:disabled) {
  background: #ffb300;
}

.btn-withdraw:disabled {
  background: #ccc;
  cursor: not-allowed;
}

/* 提现说明 */
.info-card {
  background: white;
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.info-card h4 {
  margin: 0 0 15px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.info-card ul {
  margin: 0;
  padding-left: 20px;
  list-style: disc;
}

.info-card li {
  margin-bottom: 10px;
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}

.info-card li:last-child {
  margin-bottom: 0;
}

/* 移动端适配 */
@media (max-width: 767px) {
  .wallet-page {
    padding-top: 60px;
  }

  .wallet-container {
    padding: 15px 15px 80px;
  }

  .balance-card {
    padding: 20px;
  }

  .balance-card h2 {
    font-size: 18px;
    margin-bottom: 15px;
  }

  .balance-item {
    padding: 12px;
  }

  .balance-item .label {
    font-size: 13px;
  }

  .balance-item .value {
    font-size: 20px;
  }

  .balance-item .value.highlight {
    font-size: 24px;
  }

  .withdraw-card {
    padding: 20px;
  }

  .withdraw-card h3 {
    font-size: 16px;
  }

  .form-control {
    padding: 10px 14px;
    font-size: 14px;
  }

  .btn-withdraw {
    padding: 12px 24px;
    font-size: 14px;
  }

  .info-card {
    padding: 20px;
  }

  .info-card h4 {
    font-size: 15px;
  }

  .info-card li {
    font-size: 13px;
  }

  .loading-state {
    padding: 60px 20px;
  }
  .balance-info {
    flex-direction: column;
  }
  .balance-item {
    width: 100%;
  }
  .wallet-page {
    padding-top: 10px;
  }
}
</style>
